import { MultiSelect, SelectProps } from 'react-multi-select-component';
import Box from '@mui/system/Box';

const MultiSelectBox: React.FC<SelectProps> = (props) => (
  <Box
    sx={{
      '.multiSelectFilter': {
        backgroundColor: 'transparent',

        '.dropdown-container': {
          backgroundColor: 'tertiary.main',
          borderColor: 'primary.main',
          color: 'primary.main',
          fontWeight: '600',

          '&:hover, &:focus, &:focus-within': {
            borderColor: 'primary.main',
            boxShadow: 'none',
          },

          '.dropdown-heading-value span': {
            color: 'primary.main',
            fontSize: '14px',
            fontWeight: '600',
            display: 'block',
            height: '100%',
          },

          svg: {
            height: '20px !important',
            width: 'initial',
            color: 'primary.main',
          },

          '.clear-selected-button svg': {
            display: 'none',
          },
        },

        '.options .select-item': {
          backgroundColor: 'tertiary.main',
        },

        '.MuiBadge-badge': {
          backgroundColor: 'yellow',
        },
      },
    }}
  >
    <MultiSelect {...props} />
  </Box>
);

export default MultiSelectBox;
